import Vue from 'vue'

// 定义maxlength自定义指令，用于为input/textarea元素添加字符数限制
// 该方法是为input属性添加字符数的限制，如在TextBox中添加v-maxlength="10"
Vue.directive('maxlength', {
  // bind钩子：指令第一次绑定到元素时调用，只调用一次
  // el: 指令绑定的DOM元素
  // binding: 包含指令信息的对象，binding.value是指令的绑定值
  bind(el, binding) {
      // 创建MutationObserver实例，用于监听DOM变化
      // 这是为了解决EasyUI组件异步渲染的问题，确保在真实DOM生成后设置属性
      const observer = new MutationObserver(() => {
          // 在监听的DOM变化回调中，查找input或textarea元素
          // querySelector返回第一个匹配的元素，如果没找到返回null
          const input = el.querySelector('input') || el.querySelector('textarea');
          // 检查是否找到了input元素，并且该元素还没有maxlength属性
          // hasAttribute方法用于检查元素是否已经有指定属性
          if (input && !input.hasAttribute('maxlength')) {
              // 为input元素设置maxlength属性，值来自指令绑定的值
              input.setAttribute('maxlength', binding.value);
              // 设置完成后断开观察者，避免不必要的性能开销
              observer.disconnect(); // 设置完成后停止观察
          }
      });
      
      // 开始观察DOM变化
      // 第一个参数：要观察的目标元素
      // 第二个参数：观察选项配置
      observer.observe(el, {
          // childList: true 表示观察子节点的变化（添加或删除）
          childList: true,
          // subtree: true 表示观察所有后代节点的变化，不仅仅是直接子节点
          subtree: true
      });
      
      // 立即尝试设置一次maxlength属性（如果input元素已经存在的话）
      // 这是为了处理input元素已经渲染完成的情况
      const input = el.querySelector('input') || el.querySelector('textarea');
      // 如果找到了input元素，直接设置maxlength属性
      if (input) {
          // 将指令绑定的值设置为input元素的maxlength属性
          input.setAttribute('maxlength', binding.value);
      }
  },
  
  // update钩子：当指令的绑定值发生变化时调用
  // 比如v-maxlength的值从10变为20时会触发此钩子
  update(el, binding) {
      // 重新查找input或textarea元素
      const input = el.querySelector('input') || el.querySelector('textarea');
      // 如果找到了input元素，更新其maxlength属性为新值
      if (input) {
          // 更新maxlength属性为新的绑定值
          input.setAttribute('maxlength', binding.value);
      }
  }
});
